<fui-icon class="icon" [height]="8" [icon]="'chevron-down'" [width]="12"></fui-icon>
